
export const BASE_URL = import.meta.env.VITE_BACKEND_URL

export const MIN_LENGTH_PASSWORD = 9
